import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deleteCategory, loadingSet } from "../store/actions/categoryActions";
import Swal from "sweetalert2";

export default function CategoryRow({ category, index }) {
	const navigation = useNavigate();
	const dispatch = useDispatch();

	const deleteCategoryHandler = (categoryId) => {
		Swal.fire({
			title: "Are you sure?",
			text: "You won't be able to revert this!",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes, delete it!",
		}).then((result) => {
			if (result.isConfirmed) {
				dispatch(deleteCategory(categoryId))
					.then(() => {
						Swal.fire({
							position: "top-end",
							icon: "success",
							title: "successfully deleted category",
							showConfirmButton: false,
							timer: 1000,
						});
					})
					.catch((err) => {
						return Swal.fire({
							icon: "error",
							title: "Error",
							text: err,
						});
					})
					.finally(() => {
						dispatch(loadingSet(false));
					});
			}
		});
	};

	const editCategoryHandler = (categoryId) => {
		navigation(`/categories/edit-category/${categoryId}`);
	};

	return (
		<tr className="text-center">
			<td>{index + 1}</td>
			<td>{category.name}</td>
			<td>
				<button onClick={() => editCategoryHandler(category.id)} className="btn me-1">
					Edit
				</button>
				<button onClick={() => deleteCategoryHandler(category.id)} className="btn">
					Delete
				</button>
			</td>
		</tr>
	);
}
